// Modèle : formData
// ================

'use strict';

var Model = require('models/base/model');

module.exports = Model.extend({

  defaults: {
    benefImp: 0,
    cotisRet: 0,
    cotisPrev: 0,
    cotisChom: 0,
    cotisMens: 0,
    tmi: 0
  }

});